import React from 'react';

import { styled } from '@mui/material/styles';
import { Show } from 'react-admin';

const StyledShow = styled(Show)({
    maxWidth: 'none',
});

const MaxWidthShow = (props) => {
    return (
        <StyledShow
            {...props}
        />
    );
};

export default MaxWidthShow;
